import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { FocusSection } from './components/FocusSection';
import { ProductPresentation } from './components/ProductPresentation';
import { BenefitsSection } from './components/BenefitsSection';
import { ContentSection } from './components/ContentSection';
import { BonusSection } from './components/BonusSection';
import { ClosingPhrase } from './components/ClosingPhrase';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="font-sans text-charcoal-500 antialiased bg-white min-h-screen selection:bg-sage-400 selection:text-white" data-id="element-0">
      {/* Sticky Announcement Bar */}
      <div className="w-full bg-warm-500 py-2 px-4 text-center sticky top-0 z-50" data-id="element-1">
        <span className="text-white font-medium tracking-wider uppercase text-[12px]" data-id="element-2">
          ❤️ GUÍA MAMÁS PRIMERIZAS (ACCEde hoy)
        </span>
      </div>

      <HeroSection data-id="element-3" />
      <FocusSection data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <ContentSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ClosingPhrase data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTA data-id="element-12" />

      <SocialProofPopup data-id="element-13" />

      {/* Footer */}
      <footer className="w-full bg-charcoal-700 py-8 px-6" data-id="element-14">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-15">
          <p className="text-charcoal-300 text-xs" data-id="element-16">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-charcoal-400 text-[10px] leading-relaxed" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}